import { Button } from "react-aria-components"
import { modalSignal } from "./ModalContainer"
import infoIcon from "../../../assets/icons/icon-information.svg"
import LoadingButton from "../LoadingButton"
import { useState } from "react"

interface IFullPartFullModal {
    heading: string,
    information: string,
    ContinueFunc: Function,
    cancelFunc?: Function
    autoClose?: boolean | null | undefined
}

export default function FullPartFullModal({ heading, information, ContinueFunc, cancelFunc, autoClose }: IFullPartFullModal) {
    const [loading, setLoading] = useState<boolean>(false);
    const [confirmingPartFull, setConfirmingPartFull] = useState<boolean>(false);
    const [confirmingFull, setConfirmingFull] = useState<boolean>(false);

    async function handleContinue(isFull: boolean) {
        if (isFull)
            setConfirmingFull(true)
        else
            setConfirmingPartFull(true)

        setLoading(true);
        await ContinueFunc(isFull);
        setLoading(false);
        setConfirmingFull(false)
        setConfirmingPartFull(false)
        if (autoClose == undefined || autoClose === null || autoClose === true) {
            modalSignal.value = undefined;
        }
    }

    function handleCancel() {
        modalSignal.value = undefined;
        if (cancelFunc) {
            cancelFunc();
        }
    }

    return (
        <div className="display--flex flex__direction--column alignItems--center gap--xs">
            <img src={infoIcon} />
            <h1>{heading}</h1>
            <p className="textAlign--center whitespace--pre-line">{information}</p>
            <div className="margin__top--xs display--flex gap--xs">
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleCancel} isDisabled={loading}>
                    <p className="button-text">Cancel</p>
                </Button>
                <LoadingButton className="button button--large button--primary button--with-icon"
                    onPress={async () => await handleContinue(false)}
                    buttonText="Part Full"
                    loadingText="Confirming"
                    isDisabled={loading}
                    isLoading={confirmingPartFull}>
                    <></>
                </LoadingButton>
                <LoadingButton className="button button--large button--primary button--with-icon"
                    onPress={async () => handleContinue(true)}
                    buttonText="Full"
                    loadingText="Confirming"
                    isDisabled={loading}
                    isLoading={confirmingFull}>
                    <></>
                </LoadingButton>
            </div>
        </div>)
}


